<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('surveys.title')} (ru)`" v-model="form.name_ru"></form-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('surveys.title')} (uz)`" v-model="form.name_uz"></form-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-datepicker :min-date="minDate" :label="$t('surveys.endDate')" v-model="form.ends_at"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field>
          <form-timepicker :label="$t('interface.time')" v-model="form.ends_at"></form-timepicker>
        </b-field>
      </div>
      <div class="column is-12">
        <b-checkbox v-model="allEmployees">{{ $t('interface.allEmployees') }}</b-checkbox>
      </div>
      <template v-if="!allEmployees">
        <div class="column is-6">
          <b-select class="p-0"
                    multiple
                    native-size="6"
                    v-model="selectedEmployees">
            <option v-for="employee in employeeList" :value="employee.id">{{ employee.initials }}</option>
          </b-select>
        </div>
        <div class="column is-6">
          <p class="has-text-grey-light" v-html="$t('interface.employeeSelectTip')"></p>
        </div>
      </template>
    </div>
    <h3 class="title is-6 mb-10">{{ $t('surveys.questions') }}</h3>
    <div v-for="(question, questionId) in form.questions">
      <div class="columns is-multiline">
        <div class="column is-2">
          <b-field>
            <form-input type="number" label="№" v-model="question.order_number"></form-input>
          </b-field>
        </div>
        <div class="column is-10">
          <b-field>
            <form-input :label="`${$t('surveys.questionText')} (ru) *`" v-model="question.text_ru"></form-input>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field>
            <form-select :label="$t('surveys.possibleAnswer')" v-model="question.answer_type">
              <option value="single_option">{{ $t('surveys.single_option') }}</option>
              <option value="multi_option">{{ $t('surveys.multi_option') }}</option>
            </form-select>
          </b-field>
        </div>
        <div class="column is-10">
          <b-field>
            <form-input :label="`${$t('surveys.questionText')} (uz) *`" v-model="question.text_uz"></form-input>
          </b-field>
        </div>
      </div>
      <div v-for="(option, optionId) in question.options">
        <div class="columns is-multiline">
          <div class="column is-2">
            <b-field>
              <form-input label="№" v-model="option.order_number"></form-input>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field>
              <form-input :label="`${$t('surveys.question_answer')} (ru) *`" v-model="option.value_ru"></form-input>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field>
              <form-input :label="`${$t('surveys.question_answer')} (uz) *`" v-model="option.value_uz"></form-input>
            </b-field>
          </div>
          <div class="column is-2">
            <button class="button is-danger is-small mt-15"
                    type="button"
                    @click="removeOption(questionId, optionId)">
              <span>{{ $t('interface.remove') }}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="columns mt-15">
        <div class="column is-10">
          <button class="button is-success mb-15 mr-10"
                  type="button"
                  @click="addOption(question)">
            {{ $t('surveys.addVariant') }}
          </button>
          <button class="button is-danger mb-15"
                  type="button"
                  @click="removeQuestion(questionId)">
            {{ $t('surveys.removeQuestion') }}
          </button>
        </div>
      </div>
    </div>
    <div class="field is-grouped mt-10">
      <div class="control">
        <button class="button is-warning"
                type="button"
                @click="addQuestion">
          {{ $t('surveys.addQuestion') }}
        </button>
      </div>
      <div class="control">
        <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
      </div>
      <div class="control">
        <button class="button is-danger" @click.prevent="cancel">{{ $t('interface.cancel') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState} from 'vuex'
  import {prepareDate} from '@/utils'
  const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('')

  export default {
    props: ['surveyData', 'editMode'],
    data() {
      return {
        form: this.surveyData || {
          name_ru: '',
          name_uz: '',
          description_ru: '',
          description_uz: '',
          ends_at: new Date(new Date().setHours(0, 0, 0, 0)),
          employees: [],
          questions: []
        },
        minDate: new Date(),
        isEdit: this.editMode || false,
        errors: [],
        allEmployees: true,
        selectedEmployees: this.surveyData ? this.surveyData.employees : []
      }
    },
    methods: {
      addQuestion() {
        this.form.questions.push({
          text_ru: '',
          text_uz: '',
          order_number: this.form.questions.length + 1,
          answer_type: 'single_option',
          options: []
        })
      },
      addOption(question) {
        question.options.push({
          value_ru: '',
          value_uz: '',
          order_number: alphabet[question.options.length]
        })
      },
      removeQuestion(questionId) {
        this.form.questions.splice(questionId, 1);
      },
      removeOption(questionId, optionId) {
        this.form.questions[questionId].options.splice(optionId, 1);
      },
      validate() {
        this.errors = []
        let isQuestionsEmpty = false
        let isNoOptions = false
        this.form.questions.map(question => {
          if (question.text_ru === '' || question.text_uz === '')
            isQuestionsEmpty = true
          question.options.map(option => {
            if (option.value_ru === '' || option.value_uz === '')
              isQuestionsEmpty = true
          })
          if (question.options.length === 0) {
            isNoOptions = true
          }
        })
        if (this.form.name_ru === '' || this.form.name_uz === '' || isQuestionsEmpty) {
          this.errors.push(this.$t('interface.requiredFields'))
        } else if (isNoOptions) {
          this.errors.push(this.$t('errors.noPossibleAnswer'))
        } else if (this.form.questions.length === 0) {
          this.errors.push(this.$t('errors.noQuestion'))
        }
        return this.errors.length === 0
      },
      save() {
        if (this.validate()) {
          this.$emit('save', {
            ...this.form,
            employees: this.allEmployees ? this.employeeList.map(employee => employee.id) : this.selectedEmployees
          })
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    mounted() {
      this.$store.dispatch('Survey/getEmployeeList')
    },
    computed: {
      ...mapState('Survey', ['employeeList'])
    },
    watch: {
      surveyData(data) {
        this.form = data
      }
    }
  }
</script>